export const GENDER_OPTIONS = [
  {
    label: "customer.additionalInfo.fields.gender.options.male",
    value: "1"
  },
  {
    label: "customer.additionalInfo.fields.gender.options.female",
    value: "2"
  },
  {
    label: "customer.additionalInfo.fields.gender.options.other",
    value: "3"
  }
];

export const MARITAL_STATUS_OPTIONS = [
  {
    label: "customer.data.fields.maritalStatus.options.single",
    value: "1"
  },
  {
    label: "customer.data.fields.maritalStatus.options.married",
    value: "2"
  },
  {
    label: "customer.data.fields.maritalStatus.options.engaged",
    value: "3"
  },
  {
    label: "customer.data.fields.maritalStatus.options.other",
    value: "4"
  }
];

export const PHONE_TYPE_OPTIONS = [
  {
    label: "customer.additionalInfo.fields.phoneType.options.notset",
    value: "0"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.home",
    value: "1"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.business",
    value: "2"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.mobile",
    value: "3"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.fax",
    value: "4"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.beeper",
    value: "5"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.service",
    value: "6"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.alternate",
    value: "7"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.daytime",
    value: "8"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.evening",
    value: "9"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.unknown",
    value: "10"
  },
  {
    label: "customer.additionalInfo.fields.phoneType.options.assistant",
    value: "11"
  }
];

export const CALENDAR_TYPE_OPTIONS = [
  {
    label: "customer.data.fields.calendarType.options.gregorian",
    value: "1"
  },
  {
    label: "customer.data.fields.calendarType.options.lunar",
    value: "2"
  }
];

/*export const PREFERRED_LANGUAGE_OPTIONS = [
  {
    label: "customer.lang.fields.preferredlanguage.eng",
    value: "english"
  },
  {
    label: "customer.lang.fields.preferredlanguage.fra",
    value: "france"
  }
];*/

export const CONFIRM_CONSENT_OPTIONS = [
  {
    label: "customer.consent.fields.consentAll.yes",
    value: "true"
  },
  {
    label: "customer.consent.fields.consentAll.no",
    value: "false"
  }
];

const GENDER_COLUMN = {
  value: "gender",
  label: "customer.additionalInfo.fields.gender.label",
  options: GENDER_OPTIONS
};

const MARITAL_STATUS_COLUMN = {
  value: "maritalStatus",
  label: "customer.data.fields.maritalStatus.label",
  options: MARITAL_STATUS_OPTIONS
};

const PHONE_COLUMN = {
  value: "telephone",
  label: "customer.data.fields.phone.label"
};

const POSTAL_CODE_COLUMN = {
  value: "postalCode",
  label: "customer.data.fields.address.postCode.label"
};

const NATIONALITY_COLUMN = {
  value: "nationality",
  label: "customer.data.fields.nationality.label",
  type: "customPicklist"
};

export const CUSTOMER_DETAILS_COLUMNS_JAPAN = [
  "honorificPrefix",
  "familyName",
  "givenName",
  {
    value: "alternateFamilyName1",
    label: "customer.additionalInfo.fields.globalLastName.label"
  },
  {
    value: "alternateGivenName1",
    label: "customer.additionalInfo.fields.globalFirstName.label"
  },
  GENDER_COLUMN,
  "email",
  "birthDate",
  MARITAL_STATUS_COLUMN,
  "weddingDate",
  "anniversary",
  "spouseBirthday",
  PHONE_COLUMN,
  POSTAL_CODE_COLUMN,
  {
    value: "addressRegion",
    label: "customer.data.fields.address.region.label"
  },
  {
    value: "addressLocality",
    label: "customer.data.fields.address.city.label"
  },
  {
    value: "streetAddress1",
    label: "customer.data.fields.address.line1.label"
  },
  {
    value: "streetAddress2",
    label: "customer.data.fields.address.line2.label"
  },
  {
    value: "addressCountry",
    label: "customer.data.fields.address.country.label"
  },
  "profession",
  {
    value: "confirmConsent",
    label: "customer.consent.fields.confirmConsent.label",
    options: CONFIRM_CONSENT_OPTIONS
  },
  NATIONALITY_COLUMN,
  "barcode"
];

export const CUSTOMER_DETAILS_COLUMNS = [
  "identifier",
  "honorificPrefix",
  "givenName",
  "familyName",
  GENDER_COLUMN,
  "email",
  "birthDate",
  MARITAL_STATUS_COLUMN,
  "weddingDate",
  "anniversary",
  "spouseBirthday",
  PHONE_COLUMN,
  "companyName",
  {
    value: "streetAddress1",
    label: "customer.data.fields.address.line1.label"
  },
  {
    value: "streetAddress2",
    label: "customer.data.fields.address.line2.label"
  },
  {
    value: "streetAddress3",
    label: "customer.data.fields.address.line3.label"
  },
  {
    value: "addressLocality",
    label: "customer.data.fields.address.city.label"
  },
  {
    value: "addressRegion",
    label: "customer.data.fields.address.region.label"
  },
  POSTAL_CODE_COLUMN,
  {
    value: "addressCountry",
    label: "customer.data.fields.address.country.label"
  },
  NATIONALITY_COLUMN
];

export const RESULT_FIELDS = [
  "identifier",
  "givenName",
  "familyName",
  PHONE_COLUMN,
  "email",
  POSTAL_CODE_COLUMN
];

export const RESULT_FIELDS_JAPAN = [
  "identifier",
  ["familyName", "alternateFamilyName1"],
  ["givenName", "alternateGivenName1"],
  PHONE_COLUMN,
  "email",
  POSTAL_CODE_COLUMN
];

export const COUNTRIES_WITH_REGIONS = [
  "ARG",
  "AUS",
  "BRA",
  "CAN",
  "CHN",
  "HKG",
  "ITA",
  "JPN",
  "KOR",
  "MAC",
  "MEX",
  "NZL",
  "THA",
  "USA"
];

export const POSTAL_CODE_REQUIRED_COUNTRIES = [
  "AUT",
  "BEL",
  "CAN",
  "CHE",
  "CZE",
  "DEU",
  "DNK",
  "ESP",
  "FRA",
  "GBR",
  "ITA",
  "JPN",
  "MEX",
  "NLD",
  "NZL",
  "PHL",
  "SWE",
  "THA",
  "TWN",
  "USA"
];

export const COUNTRIES_WITH_POSTAL_CODES = [
  "ARG",
  "ARM",
  "AUS",
  "AUT",
  "AZE",
  "BEL",
  "BGD",
  "BGR",
  "BLR",
  "BRA",
  "CAN",
  "CHE",
  "CHN",
  "COL",
  "CYP",
  "CZE",
  "DEU",
  "DNK",
  "DZA",
  "ECU",
  "ESP",
  "EST",
  "FIN",
  "FRA",
  "GBR",
  "GEO",
  "GGY",
  "GRC",
  "GUM",
  "HRV",
  "HUN",
  "IDN",
  "IND",
  "IRL",
  "ISR",
  "ITA",
  "JPN",
  "KAZ",
  "KGZ",
  "KOR",
  "LIE",
  "LKA",
  "LTU",
  "LUX",
  "LVA",
  "MDG",
  "MEX",
  "MHL",
  "MKD",
  "MNE",
  "MNG",
  "MTQ",
  "MYS",
  "NLD",
  "NOR",
  "NZL",
  "PAK",
  "PHL",
  "POL",
  "PRI",
  "PRT",
  "RUS",
  "SAU",
  "SGP",
  "SRB",
  "SVK",
  "SVN",
  "SWE",
  "TCA",
  "THA",
  "TJK",
  "TKM",
  "TUN",
  "TUR",
  "TWN",
  "UKR",
  "URY",
  "USA",
  "UZB",
  "VIR",
  "VNM",
  "ZAF"
];
